import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pages/$slug")({
  component: lazyRouteComponent(() => import("@/pages/admin/PageContentEditor")),
});
